<div class="donut-chart-container">
    <div class="chart-wrapper">
        <div class="chart-inner" [ngClass]="{'chart-inner-absolute': chartConfigurationObj.type === 'pieDonut'}">
            <div #chartElement  id="donut-chart" style="width:100%; height: 100%;">
            </div>
        </div>
    </div>
    <div id="donut-custom-legend" *ngIf="chartConfigurationObj.enableCustomLegend">
			<ng-template ngFor let-i="index" let-legendObj [ngForOf]="chartConfigurationObj.customLegendData">
					<app-donut-legend-item [legendItem]="legendObj" (legendClicked)="updateLegendArray($event)"></app-donut-legend-item>
			</ng-template>
    </div>
    <div style="position:absolute; top: calc(50% - 25px); left: 40%;" *ngIf="!hasData">
        No Data Available.
    </div>
</div>
